export default __webpack_public_path__ + "static/media/biomass-silage-icon.5e480099.svg";